import React, { useState, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

import { useAPI } from '../../api';
import UsersListContainer from './UsersListContainer';
import UserCreateNewContainer from './UserCreateNewContainer';
import UserContainer from './UserContainer';
import { UserInfo } from 'types';
import { useOrgContext } from 'components/OrgContextProvider';

const UsersContainer = () => {
	const api = useAPI();

	const ctx = useOrgContext();

	const [users, setUsers] = useState<UserInfo[]>([]);

	// // https://stackoverflow.com/a/46240804
	// const [, updateState] = React.useState();
	// const forceUpdate = React.useCallback(() => updateState({}), []);

	const loadUsers = () => {
		api.get<UserInfo[]>(`${ctx?.apiBase}/users`)
		.then(json => setUsers(json));
	};

	useEffect(() => {
		loadUsers();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Routes>
			<Route path="/" element={<UsersListContainer users={users} onChanged={loadUsers} />} />
			<Route path="/new" element={<UserCreateNewContainer onChanged={loadUsers} />} />
			<Route path="/:userID/*" element={<UserContainer />} />
		</Routes>
	);
};

export default UsersContainer;